<template>
  <fragment>
    <div class="modal-messages">
      <template v-if="caseClassification != caseClassificationEnum.family && caseClassification!= caseClassificationEnum.proofs">
        <naj-alert type="alert">
          <template slot="content">
            {{ local.lawsuitDetails.lawsuitFeesNote }}
            <a
              :href="Urls.judicialFees"
              target="_blank"
              class="about-link"
            >
              {{ local.common.clickHere }}
            </a>
          </template>
        </naj-alert>
      </template>

      <template v-if="notes">
        <h3>
          {{ local.lawsuitDetails.notes }}
        </h3>
        <p>
          {{ notes }}
        </p>
      </template>

      <template v-if="alert">
        <h3>
          {{ local.lawsuitDetails.alert }}
        </h3>
        <p>
          {{ alert }}
        </p>
      </template>

      <template v-if="exceptions">
        <h3>
          {{ local.lawsuitDetails.exceptions }}
        </h3>
        <p class="alert">
          {{ exceptions }}
        </p>
      </template>
    </div>

    <div
      v-if="acceptanceCriteria"
      class="modal-messages"
    >
      <h3>{{ local.lawsuitDetails.acceptanceCriteria }}</h3>
      <p
        cols="12"
        class="acceptance-criteria"
      >
        {{ acceptanceCriteria }}
      </p>
    </div>

    <template v-if="(selectedCaseType || {}).isRedirectToExternalService">
      <p
        cols="12"
        class="acceptance-criteria"
      >
        {{ local.common.redirectExternalServiceUrlMsg }}
      </p>
    </template>
  </fragment>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('LawsuitModule');
import { Urls } from '@/modules/judicialFees/helpers/enum';
import { caseClassificationEnum } from '@/helpers/enum';

export default {
  name: 'StepCaseCategoryDetailsPanel',
  props: ['notes', 'alert', 'exceptions', 'acceptanceCriteria', 'selectedCaseType', 'caseClassification'],
  data() {
    return {
      Urls,
      caseClassificationEnum,
    };
  },
  computed: { ...mapState({}) },
  methods: {},
};
</script>

<style lang="scss" scoped>
.modal-messages {
  h3 {
    font-weight: bold;
    font-size: 16px;
  }

  p {
    color: var(--app-primary-color);
    font-size: 16px;
    white-space: pre-wrap;
    padding: 20px 0px;

    &.alert {
      color: #ff4500;
    }

    &.acceptance-criteria {
      color: #484952;
    }
  }
}
.acceptance-criteria {
  font-size: 16px;
  font-weight: 400;
  white-space: pre-wrap;
}

.about-link {
  color: #144afa;
  display: inline;
}
</style>
